<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">
      {{ $t("loan applications") }}
    </div>

    <application-datatable ref="application_datatable" />
  </section>
</template>

<script>
import ApplicationDatatable from "./application_datatable/Index.vue";

export default {
  name: "LoanApplication",
  components: {
    ApplicationDatatable,
  },
};
</script>
